const allowedTags = new Set([
    'B',
    'STRONG',
    'I',
    'EM',
    'U',
    'S',
    'STRIKE',
    'BR',
    'DIV',
    'P',
    'H2',
    'H3',
    'UL',
    'OL',
    'LI',
    'TABLE',
    'TBODY',
    'THEAD',
    'TR',
    'TD',
    'TH',
]);

const indentableTags = new Set(['DIV', 'P', 'H2', 'H3']);

const escapeHtml = (value: string) =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

export const plainTextToNoteHtml = (value: string) =>
    escapeHtml(value).replace(/\n/g, '<br>');

export const noteContentToHtml = (value: string) => {
    if (!value) return '';
    if (/<\/?[a-z][\s\S]*>/i.test(value)) {
        return sanitizeNoteHtml(value);
    }

    return plainTextToNoteHtml(value);
};

export const sanitizeNoteHtml = (html: string) => {
    const template = document.createElement('template');
    template.innerHTML = html;

    const sanitizeNode = (node: Node) => {
        Array.from(node.childNodes).forEach((child) => {
            if (child.nodeType === Node.ELEMENT_NODE) {
                const element = child as HTMLElement;
                const safeChecklist =
                    element.tagName === 'UL' && element.getAttribute('data-checklist') === 'true';
                const safeChecked =
                    element.tagName === 'LI' ? element.getAttribute('data-checked') : null;
                const safeIndent =
                    indentableTags.has(element.tagName) ? element.getAttribute('data-indent') : null;

                if (!allowedTags.has(element.tagName)) {
                    const text = document.createTextNode(element.textContent || '');
                    element.replaceWith(text);
                    return;
                }

                Array.from(element.attributes).forEach((attribute) => {
                    element.removeAttribute(attribute.name);
                });

                if (safeChecklist) {
                    element.setAttribute('data-checklist', 'true');
                }

                if (safeChecked === 'true' || safeChecked === 'false') {
                    element.setAttribute('data-checked', safeChecked);
                }

                if (safeIndent && /^[1-4]$/.test(safeIndent)) {
                    element.setAttribute('data-indent', safeIndent);
                }
            }

            sanitizeNode(child);
        });
    };

    sanitizeNode(template.content);
    return template.innerHTML;
};

export const getNotePlainText = (html: string) => {
    const template = document.createElement('template');
    template.innerHTML = sanitizeNoteHtml(html);
    return template.content.textContent || '';
};
